// messages.js
export default {
	welcomeToTeaming: "Welcome to Teaming",
	teamingTour: "Teaming Tour",
	notFound: "This is not the meeting you were looking for",

	// Session

	logOut: "Log Out",
	cancel: "Cancel",
	ok: "OK",
	termsOfService: "Terms of Service",
	and: "and",
	PrivacyPolicy: "Privacy Policy",

	// Common/Shared
	AppConfirmationDialog_genericHeaderText: "Are you sure you want to continue?",
	AppConfirmationDialog_genericBodyText: "The action you are trying to take needs your confirmation to continue. Press 'Yes' to continue or 'No' to cancel",
	AppConfirmationDialog_genericCancelButtonText: "No",
	AppConfirmationDialog_genericConfirmButtonText: "Yes",

	// Reports

	meeting: "Meeting",
	//
	userSettings: "User Settings",
	notificationSettings1: "Notification Settings",
	notificationSettings2: "Tell us how you would like Teaming to reach out to you.",
	notificationSettings3: "Weekly Recap Dashboard Reminder",
	notificationSettings4: "Weekly Planner Dashboard Reminder",
	notificationSettings5: "Weekly Team Dashboard Reminder",
	notificationSettings6: "Email",
	notificationSettings11: "* - Disabling all Delivery Methods will prevent the message from being sent",
	notificationSettings12:
		"Select the messages that you want to receive and how you would like the messages delivered.",
	userNotFound:
		"Uh-oh. Teaming could not find a user account associated with the provided Google user. Please make sure that you have selected the correct Google user or if you are new to Teaming, please access our sign up page to create a new account.",

	// Teams
	teamEditHeaderCreate: "Create Your Team",
	teamEditHeaderUpdate: "Manage Your Team",
	teamEditSuccessUpdate: "Team Updated",
	teamEditSuccessCreate: "Team Created",
	teamEditInvitePending: "These members will be sent an invite via email when this team is saved",
	teamEditButtonTextUpdate: "Update Team",
	teamEditButtonTextCreate: "Create Team",
	teamEditNoTeamMembers: "There are no members currently.",
	teamEditDescription: "Teaming can't be achieved without your team. Invite your teammates to your team by entering their email addresses below.",
	teamEditInvite: "Invite your team members",
	teamEditInviteButton: "Add",
	teamEditRoleTooltip: `<b>Team leads</b> can add and remove team members. Only Team Leads can delete the team. <br/>
		<b>Team members</b> can invite new team members. They cannot remove team members or delete the team.`,

	teamInviteStatusPending: "Invitation Pending",
	teamInviteStatusInvited: "Pending Acceptance",
	teamInviteStatusActive: "Active",

	//
	// UserAvatarSpread
	//

	UserAvatarSpread_organizer: "Organizer",
};



// WEBPACK FOOTER //
// ./src/lang/en/index.js